import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToGetQuote,
    navigateToPayment,
    navigateToLivesCovered,
    navigateToDocuments,
    navigateToMedicalHistory,
} from '../../../actions/afyaImara/routing';
import { getActivePageIndex } from '../../../selectors/afyaImara/routing';
import { PAGE_INDICES } from '../../../actions/afyaImara/types';
import { apiTransitionPersonalDetailsForm } from '../../../actions/afyaImara/personalDetails';
import { apiTransitionMedicalHistoryForm } from '../../../actions/afyaImara/medicalHistory';
import { apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm } from '../../../actions/afyaImara/quote';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QUOTE:
            store.dispatch(navigateToLivesCovered());
            break;

        case PAGE_INDICES.LIVES_COVERED:
            store.dispatch(navigateToMedicalHistory());
            break;

        case PAGE_INDICES.MEDICAL_HISTORY:
             store.dispatch(navigateToPayment());
            break;

        default:
            store.dispatch(navigateToGetQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.LIVES_COVERED:
            store.dispatch(apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm.initial());
            store.dispatch(navigateToGetQuote());
            break;
        case PAGE_INDICES.MEDICAL_HISTORY:
            store.dispatch(apiTransitionPersonalDetailsForm.inital());
            store.dispatch(navigateToLivesCovered());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionMedicalHistoryForm.inital());
            store.dispatch(navigateToMedicalHistory());
            break;
        default:
            store.dispatch(navigateToGetQuote());
            break;
    }
};
